import { Button } from '../../components/Button';
import { cn } from '../../utils/formatter';

export const Error404Page = () => {
  return (
    <div className={cn(
      'min-h-screen bg-gradient-to-br from-red-50 to-orange-100',
      'flex flex-col items-center justify-center p-8'
    )}>
      <div className="text-center">
        <h1 className="text-9xl font-bold text-red-500 mb-4">404</h1>
        <h2 className="text-3xl font-semibold text-gray-800 mb-4">Página não encontrada</h2>
        <p className="text-gray-600 mb-8 max-w-md">
          A página que você está procurando não existe ou foi removida.
        </p>
        <Button 
          variant="primary" 
          onClick={() => window.history.back()}
        >
          Voltar
        </Button>
      </div>
    </div>
  );
};

export const Error502Page = () => {
  return (
    <div className={cn(
      'min-h-screen bg-gradient-to-br from-yellow-50 to-orange-100',
      'flex flex-col items-center justify-center p-8'
    )}>
      <div className="text-center">
        <h1 className="text-9xl font-bold text-yellow-500 mb-4">502</h1>
        <h2 className="text-3xl font-semibold text-gray-800 mb-4">Bad Gateway</h2>
        <p className="text-gray-600 mb-8 max-w-md">
          Erro no servidor. Tente novamente em alguns minutos.
        </p>
        <Button 
          variant="secondary" 
          onClick={() => window.location.reload()}
        >
          Tentar Novamente
        </Button>
      </div>
    </div>
  );
};

export const Error503Page = () => {
  return (
    <div className={cn(
      'min-h-screen bg-gradient-to-br from-purple-50 to-pink-100',
      'flex flex-col items-center justify-center p-8'
    )}>
      <div className="text-center">
        <h1 className="text-9xl font-bold text-purple-500 mb-4">503</h1>
        <h2 className="text-3xl font-semibold text-gray-800 mb-4">Serviço Indisponível</h2>
        <p className="text-gray-600 mb-8 max-w-md">
          O serviço está temporariamente indisponível. Tente novamente mais tarde.
        </p>
        <Button 
          variant="tertiary" 
          onClick={() => window.location.reload()}
        >
          Atualizar Página
        </Button>
      </div>
    </div>
  );
};
